/**
 * Script will be enqueued only when viewing the content on the front of the site.
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
document.addEventListener("DOMContentLoaded", function () {

    // scroll top
    document.getElementById('button-top').addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return false;
    });

    let headerObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.intersectionRatio > 0) {
                // fade out the .button-top-wrapper if the header is visible
                document.querySelector('.wp-block-doubleslash-scroll-to-top').classList.remove("is-visible");
            } else {
                // fade in the .button-top-wrapper if the header is not visible
                document.querySelector('.wp-block-doubleslash-scroll-to-top').classList.add("is-visible");
            }
        });
    });

    // observe the header
    headerObserver.observe(document.querySelector('header.wp-block-template-part:not(.fixed)'));
});
